import { Navigate } from "react-router-dom";
import React from "react";

function ProtectedRouteForDownloadReports({ children, redirectTo }) {
  const userData = localStorage.getItem("userDataFs");
  const userObj = JSON.parse(userData);

  console.log("user object", userObj);

  const isAuthorized = {
    isJoy: userObj?.responseDetails?.email == "forthsoft@admin.net",
  };

  return isAuthorized.isJoy ? children : <Navigate to={redirectTo} />;
}

export default ProtectedRouteForDownloadReports;
